module.exports = __webpack_public_path__ + "img/dashboard.826fb762.svg";